import React, { PureComponent } from 'react'
import { Form,Select,Input,Button, message} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getDetail} from '../../api/api'
import { getRandomN } from '../../utils/tool'
import instance from '../../api/bankRequest'
const { Option } = Select

@Form.create({ name: '' })
@observer
class Home extends PureComponent {

	@observable money = ''
	@observable dataInfo = ''
	@observable accTyp = '01'
	@observable data = ''
	@observable trAmt = ''

	componentDidMount(){
		this.loadData()

	}
	loadData = () =>{
		const param = {
			trxCode:'P2P024'
		}
		getDetail(param).then(res =>{
			this.data = res.data
			if(this.accTyp === '01'){
				this.money = res.data.FeeInBal/100
			}else{
				this.money = res.data.CollFeeAcBal/100
			}
		})
	}
	typeChange = (v) =>{
		const { data } = this
		this.accTyp = v
		if(v === '01'){
			this.money = data.FeeInBal/100
		}else{
			this.money = data.CollFeeAcBal/100
		}
	}
	onSubmit = (e) =>{
		e.preventDefault()
		this.props.form.validateFields((err, values) =>{
			if(!err){
				const param = {
					trxCode:'300010',
					mercOrdNo:getRandomN(),
					accTyp:values.accTyp,
					trAmt:Number(values.trAmt)*100,
				}
				console.log(param)
				if(Number(values.trAmt)<=this.money){
					message.loading('提交中',2).then(()=>{
						getDetail(param).then(res =>{
							if(res.data.rstCode === '0'){
								message.success(res.data.rstMess,1.5)
								window.location.reload()
							}else{
								message.success(res.data.rstMess,1.5)
							}
						})
					})
				}else{
					message.error('提现金额不能大于可提现金额',1.5)
				}
			}
		})
	}

	render() {
		const { dataInfo } = this
		const { getFieldDecorator } = this.props.form
		return (
			<div className="page_content">
				<div className='title'>
					<span>出金申请</span>
					<Button type='primary' className='back' onClick={() => window.history.back(-1)}>返回</Button>
				</div>
				<Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 5}} wrapperCol = {{span: 17}}>
					<Form.Item label="电子登记簿类型">
						{getFieldDecorator('accTyp', {initialValue: this.accTyp, rules: [{ required: true, message: '电子登记簿类型不能为空'}] })
						(<Select
							onChange={this.typeChange}
							placeholder='请选择电子登记簿类型'
							>
							<Option value={'01'} key={'01'}>手续费收入电子登记簿</Option>
							<Option value={'04'} key={'04'}>代收渠道手续费电子登记簿</Option>
						</Select>) }
					</Form.Item>
					<Form.Item label="账户余额">
                       <span style={{fontSize:28,color:'red'}}>￥{this.money}</span>
                    </Form.Item>
					<Form.Item label="出金金额">
                        {getFieldDecorator('trAmt', {initialValue: this.trAmt, rules: [{ required: true, message: '出金金额不能为空'}] })(
                        <Input placeholder="请输入出金金额" />)}
                    </Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit"  style={{ width: 200,borderRadius:20,height:40,marginLeft:200}}>提交</Button>
					</Form.Item>
				</Form>
				<Form method='post' action={instance.baseURL+'/bhdep/payTransactionNew'} style={{display:'none'}} >
                    <Input type='text' name='INFO' value={dataInfo? dataInfo[0].substring(5):''}/>
                    <Input type='text' name='BODY' value={dataInfo? dataInfo[1].substring(5):''}/>
                    <Input type='text' name='SIGN' value={dataInfo? dataInfo[2].substring(5):''}/>
                    <Input type='text' name='CONTENTTYPE' value='json'/>
                    <Input type='submit' value='提交' />
                </Form>
			</div>
		)
	}
}
export default Home
